import { useOutletContext } from 'react-router-dom'
import Markdown from '../Markdown/Markdown'
import styles from './LegalMarkdown.module.scss'

function LegalMarkdown() {
  const { sectiondata } = useOutletContext() || {}

  return (
    <div
      className={styles.container}
      style={{
        direction: 'ltr',
      }}
    >
      <Markdown content={sectiondata?.description} />
    </div>
  )
}

export default LegalMarkdown
